import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type CreateAttachmentRequest = InferRequestType<
  typeof apiClient.attachments.$post
>['json']
type CreateAttachmentResponse = InferResponseType<
  typeof apiClient.attachments.$post
>

export type UseCreateAttachmentArgs = CreateAttachmentRequest

export const useCreateAttachment = (
  options?: UseMutationOptions<
    CreateAttachmentResponse,
    Error,
    CreateAttachmentRequest
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.attachments
        .$post({
          json: variables,
        })
        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['attachment-create'],
    ...options,
  })
